import { useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import { PaymentMethod } from "../../../../../api/tournament-participant";
import { WideState } from "../../../../../recoil/wide";

export const usePaymentTypes = () => {
  const [cash, setCash] = useState<number>(0);
  const [card, setCard] = useState<number>(0);
  const [bank, setBank] = useState<number>(0);
  const [point, setPoint] = useState<number>(0);
  const [discount, setDiscount] = useState<number>(0);
  const [seed, setSeed] = useState<number>(0);
  const [description, setDescription] = useState<string>("");
  const prevCash = useRef(cash);
  const prevCard = useRef(card);
  const prevBank = useRef(bank);
  const prevPoint = useRef(point);
  const prevDiscount = useRef(discount);
  const prevSeed = useRef(seed);
  const isWide = useRecoilValue(WideState);

  const payType = [
    {
      name: "현금",
      type: PaymentMethod.CASH,
      value: cash,
      set: setCash,
      prev: prevCash,
    },
    {
      name: "신용카드",
      type: PaymentMethod.CARD,
      value: card,
      set: setCard,
      prev: prevCard,
    },
    {
      name: "계좌",
      type: PaymentMethod.BANK_TRANSFER,
      value: bank,
      set: setBank,
      prev: prevBank,
    },
    {
      name: isWide ? "매장 이용권" : "E",
      type: PaymentMethod.POINTS,
      value: point,
      set: setPoint,
      prev: prevPoint,
      unit: "E",
    },
    {
      name: "할인",
      type: PaymentMethod.DISCOUNT,
      value: discount,
      set: setDiscount,
      prev: prevDiscount,
    },
    {
      name: isWide ? "크레딧" : "RB",
      type: PaymentMethod.SEED,
      value: seed,
      set: setSeed,
      prev: prevSeed,
      unit: "RABBIT",
    },
  ];

  const clearPayType = () => {
    for (const type of payType) {
      type.set(0);
    }
  };

  return {
    payType,
    description,
    setDescription,
    clearPayType,
  };
};
